<template>
    <div class="modal">
        <div class="modal__container">
            <div class="modal__inner modal__inner--secondary">
                <!-- <h3 class="modal__ttl  modal__ttl--primary"></h3> -->
                <h4 class="modal__ttl modal__ttl--primary">
                    {{ activeTicket.acknowledgement.title }}
                </h4>

                <div class="modal__content">
                    <div class="acknowledgement-content">
                        <p v-html="activeTicket.acknowledgement.content"></p>
                    </div>

                    <div class="mt-7 mb-5">
                        <label for="acknowledgement-agree" class="acknowledgement-agree">
                            <input
                                type="checkbox"
                                id="acknowledgement-agree"
                                class="mr-2"
                                v-model="agreed"
                            />
                            {{ activeTicket.acknowledgement.agree_label }}
                        </label>
                    </div>

                    <button
                        class="btn btn--secondary mr-3"
                        @click.prevent="close"
                    >
                        <span>{{ __("Cancel") }}</span>
                    </button>

                    <button class="btn btn--quaternary" @click.prevent="accept">
                        <span>{{ __("Add to Basket") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "seat-picker-acknowledgement-modal",

    props: {
        activeTicket: {
            type: Object,
            default: false,
        },
    },

    data: (instance) => {
        return {
            agreed: false,
        };
    },
    methods: {
        accept() {
            if (!this.agreed) {
                this.$toasted.show('Please agree to the terms of this ticket', {
                    theme: "bubble",
                    type: 'error',
                    position: "top-center",
                    duration: 3000
                });
                return;
            }
            this.$emit("accept", this.activeTicket);
        },
        close() {
            this.$emit("close", true);
        },
    },
};
</script>
<style lang="scss" scoped>
.mb-5 {
    margin-bottom: 1.25rem;
}
.mt-7 {
    margin-bottom: 1.75rem;
}
.mr-3 {
    margin-right: 0.75rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.modal__content {
    text-align: center;
    padding: 20px;
    background-color: rgba(255,255,255,0.9);

    .acknowledgement-content{
        color: #000;
        max-height: 65vh;
        overflow-y: auto;
        padding: 20px;
        margin-bottom: 10px;
    }
}
h4 {
    &.modal__ttl--primary {
        font-size: 24px;
    }
}
.modal__close {
    margin-top: 40px;
}
option {
    color: #000;
    background: #fff;
}
.acknowledgement-agree{
    color: #000;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/SeatPickerAcknowledgementModal.vue